/* eslint-disable */
import React, { useState } from 'react';
import Form from './Form';
import './components.css';
import { useStateValue } from '../ContextApi/StateProvider';

const SetRow = (props) => {
    const [errors, setErrors] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [repetitions, setRepetitions] = useState(0);
    const [initialState] = useStateValue();
    const authUser = JSON.parse(initialState.authenticatedUser);

    const change = (event, setState) => {
        const value = event.target.value;
        setState(value);
        console.log(repetitions);
    };

    const cancel = () => setEditMode(false);

    const deleteSet = () => {
        let workoutId = parseInt(props.workoutId);
        let exerciseId = parseInt(props.exerciseId);
        let id = props.id;

        if (window.confirm("Are sure you want to delete this set? Once deleted, it cannot be retrieved.")) {
            initialState.SetsRequests.deleteSet(workoutId, exerciseId, id, authUser.emailAddress, authUser.password)
                .then((response) => {
                    if (response === 'success') {
                        props.callback();
                        alert("Set deleted.");
                    } else {
                        props.history.push('/error');
                    }
                })
                .catch(err => {
                    console.log(err);
                    props.history.push('/error');
                });
        }
    };

    const submit = () => {
        let workoutId = parseInt(props.workoutId);
        let exerciseId = parseInt(props.exerciseId);
        let id = props.id;
        const reps = { repetitions };

        initialState.SetsRequests.updateSet(workoutId, exerciseId, id, reps, authUser.emailAddress, authUser.password)
            .then((response) => {
                if (response === "success") {
                    console.log(`${authUser.emailAddress} updated set: ${reps}`);
                    setEditMode(false);
                    props.callback();
                } else if (response === "forbidden") {
                    setErrors([...errors, "You do not have permission to update set."]);
                } else {
                    setErrors([...errors, response]);
                    console.log(errors);
                }
            })
            .catch(err => setErrors([...errors, err]));
    };

    return (
        <div>
            {editMode ? (
                <Form
                    cancel={cancel}
                    submit={submit}
                    cancelButtonText="Back"
                    submitButtonText="Update Set"
                    elements={() => (
                        <>
                            {errors.map((error, i) => (
                                <p key={i} className="set-row-error-message">{error}</p>
                            ))}
                            <div className="set-row-form-row">
                                <label htmlFor="repNumber" className="form-label">
                                    #{props.index} - Enter Reps:
                                </label>
                                <input
                                    id="repNumber"
                                    name="repNumber"
                                    type="number"
                                    placeholder={props.repetitions}
                                    onChange={(e) => change(e, setRepetitions)}
                                    required
                                    className="input-2025"
                                />
                            </div>
                        </>
                    )}
                />
            ) : (
                <div className="exercise-set-row">
                    <p>Set #{props.index}</p>
                    <p>Reps: {props.repetitions}</p>
                    <button className="btn-2025" onClick={() => setEditMode(true)}>Edit</button>
                    <button className="btn-2025" onClick={deleteSet}>Delete</button>
                </div>
            )}
        </div>
    );
};

export default SetRow;